import { useEffect, useState } from 'react';
import appConstants from '../../../../appConstants';
import ShipperQuickFilter from './ShipperFilter';
import CustomerQuickFilter from './CustomerFilter';

const CustomerManagementQuickFilter = (props) => {
  const [filterName, setFilterName] = useState(
    appConstants.IBPLANNING_QUICKFILTER_NAMES.CUSTOMER_GRID
  );

  useEffect(() => {
    props.glContainer.layoutManager.on('activeContentItemChanged', updateQuickFilterOnTabSwitch);

    return () => {
      props.glContainer.layoutManager.off('activeContentItemChanged', updateQuickFilterOnTabSwitch);
    };
  }, []);

  const updateQuickFilterOnTabSwitch = (contentItem) => {
    const newFilterName =
      contentItem.config.id === appConstants.gridNames.CustomerGrid
        ? appConstants.IBPLANNING_QUICKFILTER_NAMES.CUSTOMER_GRID
        : appConstants.IBPLANNING_QUICKFILTER_NAMES.SHIPPER_GRID;
    setFilterName(newFilterName);
    props.glEventHub.emit(`activeTabSwitched_${contentItem.config.id}`);
  };

  const getCustomStyles = () => {
    let [customerDisplay, shipperDisplay] = ['none', 'none'];
    if (filterName === appConstants.IBPLANNING_QUICKFILTER_NAMES.CUSTOMER_GRID) {
      customerDisplay = 'block';
    } else {
      shipperDisplay = 'block';
    }
    return { customerDisplay, shipperDisplay };
  };

  const getQuickFilterStylesByFilterName = () => {
    const height = '100%';
    const { customerDisplay, shipperDisplay } = getCustomStyles();
    return {
      customerStyles: { display: customerDisplay, height },
      shipperStyles: { display: shipperDisplay, height }
    };
  };

  const { customerStyles, shipperStyles } = getQuickFilterStylesByFilterName();

  return (
    <>
      <div style={customerStyles}>
        <CustomerQuickFilter
          {...props}
          filterName={appConstants.IBPLANNING_QUICKFILTER_NAMES.CUSTOMER_GRID}
        />
      </div>
      <div style={shipperStyles}>
        <ShipperQuickFilter
          {...props}
          filterName={appConstants.IBPLANNING_QUICKFILTER_NAMES.SHIPPER_GRID}
        />
      </div>
    </>
  );
};

export default CustomerManagementQuickFilter;
